import Promise from 'promise-polyfill';

/**
 * Dynamically loads a CSS stylesheet by inserting a link tag after the last global UI stylesheet.
 * Skips loading if the stylesheet is already present in the DOM.
 *
 * @param {string} url - The URL of the stylesheet to load
 * @returns {Promise<void>} Resolves immediately (IE 11 does not support link onload)
 */
function loadStyle(url) {
	if (document.querySelector(`link[href="${url}"]`)) {
		return Promise.resolve();
	}

	const linkTag = document.createElement('link');
	linkTag.href = url;
	linkTag.rel = 'stylesheet';

	const globalCss = document.querySelectorAll('link[href*="/ui/"]');
	const lastGlobalCss = globalCss[globalCss.length - 1];
	lastGlobalCss.insertAdjacentElement('afterend', linkTag);

	// IE 11 does not support link tag onload callback, just resolving the promise for now
	return Promise.resolve();
}

export default loadStyle;
